<template>
    <div :id="maindivid">

        <input :id="txtid" 
               v-model="selectedText" 
               type="text" 
               v-bind="attrs"
               class="fontSizeAll ctrlTextbox"
               @input="handleTextboxInput" 
               @blur="handleTextboxBlur"
               :placeholder="placeHolderText" />

        <ul v-show="showOptionsList" :id="ulid" class="ulOptionsList">

            <li id="AclistItemCtrlID" 
                class="liSelect ctrlTextbox" v-for="lastNameObj in filteredOptionsList"
                :key="lastNameObj"
                @mousedown="handleListMouseDown($event)" 
                @click="handleListClick($event, lastNameObj.text)">

                {{ lastNameObj.text }}

            </li>

        </ul>

    </div>
</template>
  
<script>

export default {

    inheritAttrs: false,
    setup(props, {attrs}) {
        return {attrs};;
    },
    data() {
        return {
            selectedText: '',

            filteredOptionsList: null,
            optionsList: null,
            showOptionsList: false,

            placeHolderText: null,
            controlWidth: 300,
            textboxStyle: null,

            // ----------- control IDs

            maindivid: this.CreateCtrlID(),
            txtid: this.CreateCtrlID(),
            ulid: this.CreateCtrlID(),

        };
    },
    props: {
        OptionsList: { type: Object, require: true },
        PlaceHolderText: { type: String, require: false },
        ControlWidth: { type: Number, require: false },
        TextboxStyle: { type: String, require: false },
        SelectedText: { type: Object, require: false },
    },
    emits: ['itemSelected'],
    watch: {
        OptionsList: {
            handler: function () {
                this.OptionsListFnc();
            },
            flush: "post",
        },
        PlaceHolderText: {
            handler: function () {
                this.PlaceHolderTextFnc();
            },
            flush: "post",
        },
        ControlWidth: {
            handler: function () {
                this.ControlWidthFnc();
            },
            flush: "post",
        },
        TextboxStyle: {
            handler: function () {
                this.TextboxStyleFnc();
            },
            flush: "post",
        },
        SelectedText: {
            handler: function () {
                this.SelectedTextFnc();
            },
            flush: "post",
        },
    },

    created() {
        this.OptionsListFnc();
        this.PlaceHolderTextFnc();
        this.ControlWidthFnc();
        this.TextboxStyleFnc();
        this.SelectedTextFnc();
    },

    mounted() {
        this.setStylesDynamically();
    },

    components: {},
    computed: {},

    methods: {


        // ----------------- Generate IDs

        CreateCtrlID() {
            let letterString = '';
            for (let i = 0; i < 15; i++) {

                letterString = letterString + String.fromCharCode(97+Math.floor(Math.random() * 26));
            }
            return letterString;
        },

        setStylesDynamically() {

            // console.log('this.$data.textboxStyle = ', this.$data.textboxStyle);

            // --------- main div
            let localDivId = '#' + this.$data.maindivid;
            // console.log('localDivId = ', localDivId);

            let AcTextboxDivCtrl = document.querySelector(localDivId);
            AcTextboxDivCtrl.style.width = this.$data.controlWidth + "px";

            // -------- textbox
            let localTxtId = '#' + this.$data.txtid;
            // console.log('localTxtId = ', localTxtId);

            let textboxCtrl = document.querySelector(localTxtId);
            textboxCtrl.style = this.$data.textboxStyle;
            textboxCtrl.style.width = this.$data.controlWidth + "px";

            // ------------ ul
            let localUlId = '#' + this.$data.ulid;
            // console.log('localUlId = ', localUlId);

            let ulCtrl = document.querySelector(localUlId);
            ulCtrl.style.width = this.$data.controlWidth + "px";

        },

        // ---------------- watch handlers ----------------------

        OptionsListFnc() {
            this.$data.optionsList = new Array();
            if (this.OptionsList) {
                for (let element of this.OptionsList) {
                    this.$data.optionsList.push(element);
                }
            }
        },

        PlaceHolderTextFnc() {
            if (this.PlaceHolderText) {
                this.$data.placeHolderText = this.PlaceHolderText;
            }
        },

        ControlWidthFnc() {
            if (this.ControlWidth) {
                this.$data.controlWidth = this.ControlWidth;
            }
        },

        TextboxStyleFnc() {
            if (this.TextboxStyle) {
                this.$data.textboxStyle = this.TextboxStyle;
            }
        },

        SelectedTextFnc() {
            // console.log('--- SelectedTextFnc ---');
            // console.log('AcTextbpx: this.SelectedText = ', this.SelectedText);
            if (this.SelectedText){
                this.$data.selectedText = this.SelectedText.text;
            }
        },

        // -------------------- List Event Handlers -------------------------------

        handleListMouseDown(event) {
            //This prevents the textbox blur event from being called.
            //We don't want the blur event firing in the event that 
            //the list was clicked on.
            event.preventDefault();
        },

        handleListClick(event, name) {
            this.$data.selectedText = name;
            this.$data.showOptionsList = false;
            this.$emit('itemSelected', this.$data.selectedText);
        },

        // -------------------- Textbox Event Handlers -------------------------------

        handleTextboxInput() {

            if (this.$data.selectedText == null) {
                this.$data.showOptionsList = false;
            } else if (this.$data.selectedText.trim().length == 0) {
                this.$data.showOptionsList = false;
            } else {
                this.$data.filteredOptionsList = this.optionsList.filter(
                    lastNameObj => lastNameObj.text.toLowerCase().includes(this.$data.selectedText.toLowerCase()));
                if (this.$data.filteredOptionsList.length > 0) {
                    this.$data.showOptionsList = true;
                } else {
                    this.$data.showOptionsList = false;
                }
            }
        },

        handleTextboxBlur() {
            this.$data.showOptionsList = false;
            this.$emit('itemSelected', this.$data.selectedText);
        },

        // ---------------------------------------------------
        // --------------- END Methods -----------------------
        // ---------------------------------------------------
    },
};
</script>
  
<style scoped>

.ulOptionsList {
    border: 1px solid black;
    list-style-type: none;
    text-align: left;
    overflow: auto;
    white-space: nowrap;

    position: absolute;
    background-color: white;

    margin-top: 1px;
    max-height: 200px;
    padding: 10px;
    padding-left: 10px;

}

.liSelect {
    cursor: pointer;
    font-size: smaller;
}

.liSelect:hover {

    border: 1px solid darkblue;
    background-color: #e6ecff;
    border-radius: 6px;
    color: blue;
    font-weight: bold;
    font-size: normal;
}

.fontSizeAll {
  font-size: smaller;
}

.ctrlTextbox {
  padding: 0px;
  margin: 0px;
}


</style>
  